import type { AgentRecord, PolicyRecord } from "./getDemoData.types"
import type {
  HardeningAgent,
  HardeningSuggestion
} from "./getHardeningSuggestions.types"

// TriageAgent keeps a fixed policy id and name: the UNSANCTIONED_NETWORK_ACCESS
// demo incident (TriagePage demo data) links to this policy by id.
const HARDENING_AGENT_NAME = "TriageAgent"
const TRIAGE_AGENT_HARDENING_POLICY = {
  id: "3.2",
  name: "TriageAgent hardening"
}

export const getAgentPolicyId = (agent: Pick<HardeningAgent, "id" | "name">) =>
  agent.name === HARDENING_AGENT_NAME
    ? TRIAGE_AGENT_HARDENING_POLICY.id
    : `hardening-${agent.id}`

export const getAgentPolicyName = (agentName: string) =>
  agentName === HARDENING_AGENT_NAME
    ? TRIAGE_AGENT_HARDENING_POLICY.name
    : `${agentName} hardening`

export const getAgentPolicyDescription = (agentName: string) =>
  `Restricts ${agentName} and its tools to their intended behavior based on code and runtime analysis. Blocks violations and sends notifications.`

// Approved rules are enforced at runtime and notify, like the generated
// hardening policy they come from.
const ENFORCED_ACTIONS: PolicyRecord["actions"] = {
  enabled: true,
  enforceRuleOnRuntime: true,
  preventViolationOnDevelopment: false,
  notifyOnViolation: true
}

export const toPolicyGroup = (
  suggestion: HardeningSuggestion
): PolicyRecord => ({
  rules: [suggestion.condition],
  actions: ENFORCED_ACTIONS
})

// A new, empty policy of the agent's own. Approved suggestions or drawer edits
// fill its rules; the inherited policy stays as it is.
export const newAgentPolicy = (
  agent: Pick<HardeningAgent, "id" | "name">
): AgentRecord => {
  const id = getAgentPolicyId(agent)

  return {
    id,
    key: id,
    scopeId: id,
    type: "agent",
    name: agent.name,
    count: 1,
    total: 1,
    overrides: "",
    category: "Hardening",
    grantedBy: "Kodem",
    expires: "",
    description: "1 agent",
    policyId: id,
    policyName: getAgentPolicyName(agent.name),
    policyDescription: getAgentPolicyDescription(agent.name),
    violated: false,
    agentsDescription: `${agent.name} runs these rules.`,
    allowed: [],
    notAllowed: []
  }
}
